import {
  getListOfRoles,
  createRole,
  createRoleV2,
  attachResponsibilityToRole,
  createResponsibility,
  updateActiveRole,
  updateRetiredRole,
  updateArchiveRole,
  updateUnArchiveRole,
  deleteReadinessRole,
  deleteReadinessRoleWithResponsibilities,
  updateDeActiveRole,
  updateReActiveRole,
  getPositionId,
  detachOrgObject,
  detachAttachments,
  detachRoleAttachment,
  getChatterList,
  updateNameRole,
  getListofEmployeeV1,
} from "@/api";

import AddRoleDialog from "@components/RolesCatalog/AddRoleDialog/AddRoleDialog.vue";
import ActivateRole from "@components/RolesCatalog/ActivateRole.vue";
import AttachedRole from "@components/RolesCatalog/AttachedRole.vue";
import RetiredRole from "@components/RolesCatalog/RetiredRole.vue";
import DeleteRole from "@components/RolesCatalog/DeleteRole.vue";
import RenameRole from "@components/RolesCatalog/RenameRole.vue";
import DeActivateRole from "@components/RolesCatalog/DeActivateRole.vue";
import ReActivateRole from "@components/RolesCatalog/ReActivateRole.vue";
import DetachDialog from "@components/DetachDialog/DetachDialog.vue";
import { useHighlightRow } from "@/composables/common/useHighlightRow";
const { highlight } = useHighlightRow();
export default {
  components: {
    AddRoleDialog,
    ActivateRole,
    DeleteRole,
    RenameRole,
    AttachedRole,
    RetiredRole,
    DeActivateRole,
    ReActivateRole,
    DetachDialog,
  },
  data() {
    return {
      detachLoader: false, // Initialize the loader state
      rolesPaginationModel: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      responsibilitiesPaginationModel: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      paginationOrgRoleModel: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      paginationRolePageModel: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      chatterData: [], // Chatter items list
      totalChatterData: 0, // Total count of chatter items
    };
  },
  computed: {
    isLoading() {
      return this.detachLoader;
    },
    storeRoles() {
      return this.$store.state.readinessCatalogsStore.roles;
    },
    storeResponsibilities() {
      return this.$store.state.readinessCatalogsStore.responsibilities;
    },
    currentPaginationModel() {
      const routeParams = this.$route?.params?.type || "roles";
      if (routeParams === "responsibilities") {
        return this.responsibilitiesPaginationModel;
      } else if(routeParams === "roles") {
        return this.rolesPaginationModel;
      } else {
        return this.paginationModel;
      }
    },
    sanitizeDataSourceforReadinessCatalogs() {
      try {
        let rolesArray = [];
        if (this.storeRoles && this.storeRoles.length > 0) {
          rolesArray = this.storeRoles.map((el) => {
            // Check if role has responsibilities attached
            const hasResponsibilities = el.responsibility_attachment_count > 0

            return {
              id: el.id,
              parentId: -1,
              status: el.status,
              archived: el.archived,
              has_items: hasResponsibilities,
              type: "role",              
              data: {
                type: "role",
                code: el.code + "",
                name: el.name,
                status: el.status,
              },
              info: {
                ...el,
              },
            };
          });
        }

        let responsibilitiesCopy = [];

        if (
          this.storeResponsibilities &&
          this.storeResponsibilities.length > 0
        ) {
          responsibilitiesCopy = this.storeResponsibilities.map((el) => {
            const newEl = {};
            newEl.id = el.id;
            newEl.realId = el.id;
            newEl.parentId = -1;
            newEl.status = el.status;
            newEl.archived = el.archived;
            el.code = el.code + "";
            newEl.has_items = false;
            newEl.data = {
              type: "responsibility",
              ...el,
            };
            newEl.type = "responsibility";
            return newEl;
          });
        }
        let routeParams = this.$route?.params?.type || "roles";
        if (routeParams == "responsibilities") {
          return responsibilitiesCopy;
        } else {
          return rolesArray;
        }
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
    sanitizeDataSource() {
      try {
        let rolesArray = [];
        if (this.storeRoles && this.storeRoles.length > 0) {
          rolesArray = this.storeRoles.map((el) => {
            let typeCountMap = [];
            if (el.attachments && el.attachments.length > 0) {
              typeCountMap = el.attachments.reduce((acc, att) => {
                acc[att.type] = (acc[att.type] || 0) + 1;
                return acc;
              }, {});
            }
            el.attachmentss = Object.entries(typeCountMap).map(
              ([type, quantity]) => ({ type, quantity })
            );

            let totalCount = 0;
            if (el.attachments_count) {
              totalCount = Object.values(el.attachments_count).reduce(
                (sum, count) => sum + count,
                0
              );
            }
            return {
              id: el.id,
              parentId: -1,
              status: el.status,
              archived: el.archived,
              data: {
                type: "role",
                code: el.code + "",
                name: el.name,
                status: el.status,
              },
              info: {
                ...el,
              },
              attachedTo: {
                data: el.attachmentss,
              },
              attachedToItems: {
                data: el.attachments,
              },
              attachments_count: el.attachments_count,
              assignment: totalCount,
              types: "",
            };
          });
        }
        const itemsToAdd = [];

        let responsibilitiesCopy = [];

        if (
          this.storeResponsibilities &&
          this.storeResponsibilities.length > 0
        ) {
          responsibilitiesCopy = this.storeResponsibilities.map((el) => {
            const newEl = {};
            newEl.id = el.id;
            newEl.realId = el.id;
            newEl.parentId = -1;
            newEl.status = el.status;
            newEl.archived = el.archived;
            el.code = el.code + "";
            newEl.data = {
              type: "responsibility",
              ...el,
            };
            newEl.type = "responsibility";
            newEl.types = "";
            let typeCountRes = [];
            if (el.attachments && el.attachments.length > 0) {
              typeCountRes = el.attachments.reduce((acc, att) => {
                acc[att.type] = (acc[att.type] || 0) + 1;
                return acc;
              }, {});
            }
            newEl.data.attachments = el.attachments || [];
            newEl.attachedTo = {
              data: Object.entries(typeCountRes).map(
                ([type, quantity]) => ({ type, quantity })
              ),
            };
            newEl.attachedToItems = {
              data: el.attachments || [],
            };
            newEl.attachments_count = el.attachments_count;
            newEl.assignment = Object.values(el.attachments_count || {}).reduce(
              (sum, count) => sum + count,
              0
            );
            return newEl;
          });
        }
        rolesArray.forEach((el) => {
          const responsibilitiesAttachments =
            el.info.attachments?.filter((ra) => ra.type == "responsibility") ||
            [];
          responsibilitiesAttachments.forEach((el2) => {
            const tempItem = responsibilitiesCopy.find(
              (res) => res.id == el2.id
            );
            if (tempItem) {
              const tempItemCopy = JSON.parse(JSON.stringify(tempItem));
              if (tempItemCopy) {
                let newId = itemsToAdd.length + 500;
                while (newId == el.id) {
                  newId = newId + 1000;
                }
                tempItemCopy.id = newId;
                tempItemCopy.realId = tempItem.id;
                tempItemCopy.parentId = el.id;
                tempItemCopy.type = "roles";
                itemsToAdd.push(tempItemCopy);
              }
            }
          });
        });
        const finalArray = JSON.parse(
          JSON.stringify(rolesArray.concat(itemsToAdd))
        );
        let routeParams = this.$route?.params?.type || "roles";
        if (routeParams == "responsibilities") {
          if (this.dataSource.length > 0) {
            return this.applyFiltersToDataSource(this.dataSource, routeParams);
          } else {
            return this.applyFiltersToDataSource(
              JSON.parse(JSON.stringify(responsibilitiesCopy)),
              routeParams
            );
          }
        } else {
          if (this.dataSource.length > 0) {
            return this.applyFiltersToDataSource(this.dataSource, routeParams);
          } else {
            return this.applyFiltersToDataSource(finalArray, routeParams);
          }
        }
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
    originalDataSource() {
      try {
        let rolesArray = [];
        if (this.storeRoles && this.storeRoles.length > 0) {
          rolesArray = this.storeRoles.map((el) => {
            let typeCountMap = [];
            if (el.attachments && el.attachments.length > 0) {
              typeCountMap = el.attachments.reduce((acc, att) => {
                acc[att.type] = (acc[att.type] || 0) + 1;
                return acc;
              }, {});
            }
            el.attachmentss = Object.entries(typeCountMap).map(
              ([type, quantity]) => ({ type, quantity })
            );

            let totalCount = 0;
            if (el.attachments_count) {
              totalCount = Object.values(el.attachments_count).reduce(
                (sum, count) => sum + count,
                0
              );
            }

            // Check if role has responsibilities attached
            const hasResponsibilities = el.responsibility_attachment_count > 0 || 
              (el.attachments && el.attachments.some(att => att.type === 'responsibility'));

            return {
              id: el.id,
              parentId: -1,
              status: el.status,
              archived: el.archived,
              has_items: hasResponsibilities,
              data: {
                type: "role",
                code: el.code + "",
                name: el.name,
                status: el?.status,
              },
              info: {
                ...el,
              },
              attachedTo: {
                data: el.attachmentss,
              },
              assignment: totalCount,
              types: "",
            };
          });
        }
        const itemsToAdd = [];

        let responsibilitiesCopy = [];

        if (
          this.storeResponsibilities &&
          this.storeResponsibilities.length > 0
        ) {
          responsibilitiesCopy = this.storeResponsibilities.map((el) => {
            const newEl = {};
            newEl.id = el.id;
            newEl.realId = el.id;
            newEl.parentId = -1;
            newEl.status = el.status;
            newEl.archived = el.archived;
            newEl.has_items = false;
            el.code = el.code + "";
            newEl.data = {
              type: "responsibility",
              ...el,
            };
            newEl.type = "responsibility";
            return newEl;
          });
        }
        rolesArray.forEach((el) => {
          const responsibilitiesAttachments =
            el.info.attachments?.filter((ra) => ra.type == "responsibility") ||
            [];
          responsibilitiesAttachments.forEach((el2) => {
            const tempItem = responsibilitiesCopy.find(
              (res) => res.id == el2.id
            );
            if (tempItem) {
              const tempItemCopy = JSON.parse(JSON.stringify(tempItem));
              if (tempItemCopy) {
                let newId = itemsToAdd.length + 500;
                while (newId == el.id) {
                  newId = newId + 1000;
                }
                tempItemCopy.id = newId;
                tempItemCopy.realId = tempItem.id;
                tempItemCopy.parentId = el.id;
                tempItemCopy.type = "roles";
                itemsToAdd.push(tempItemCopy);
              }
            }
          });
        });
        const finalArray = JSON.parse(
          JSON.stringify(rolesArray.concat(itemsToAdd))
        );
        const routeParams = this.$route.params.type;
        if (routeParams == "responsibilities") {
          return JSON.parse(JSON.stringify(responsibilitiesCopy));
        } else {
          return finalArray;
        }
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
  },
  methods: {
    async loadNewDataSourceForReadinessCatalogs() {
      // await this.$store.dispatch("readinessCatalogsStore/loadRoles");
      if (this.$route?.params?.type === "roles") {
        await this.$store.dispatch("readinessCatalogsStore/loadRolesV2", { limit: 10, offset: 0, ordering: this.$store?.state?.readinessCatalogsStore?.ordering });
        const rolesCount = this.$store.state.readinessCatalogsStore.rolesCount;
        this.rolesPaginationModel = {
          page: 1,
          total: Math.ceil(rolesCount),
          perPage: 10,
        };
      } else if (this.$route?.params?.type === "responsibilities") {
          await this.$store.dispatch("readinessCatalogsStore/loadResponsibilitiesV2", { limit: 10, offset: 0, include_badge_holders: true });
          const responsibilitiesCount = this.$store.state.readinessCatalogsStore.responsibilitiesCount;
          this.responsibilitiesPaginationModel = {
            page: 1,
            total: Math.ceil(responsibilitiesCount),
            perPage: 10,
          };
      } else {}
    },
    async loadDataSourceForReadinessCatalogs({limit = 10, offset = 0, search = '', filters = [], page = 1, ordering = null}) {
      try {
        let roleList = [];
        let responsibilities = [];
        let itemsToAdd = [];
        let responsibilitiesCopy = [];
        let rolesArray = [];
        if (this.$route?.params?.type === "roles") {
          const apiFilters = this.convertFiltersToAPIFormat(filters);
        
          // Only include search and filters if they have meaningful values
          const requestParams = { limit, offset };
          if (search && search.trim()) {
            requestParams.search = search;
          }
          if (Object.keys(apiFilters).length > 0) {
            requestParams.filters = apiFilters;
          }
          if (ordering) {
            requestParams.ordering = ordering === "data" ? "name" : ordering;
          } else if (this.$store?.state?.readinessCatalogsStore?.ordering) {
            requestParams.ordering = this.$store.state.readinessCatalogsStore.ordering;
          }
         roleList = await this.$store.dispatch("readinessCatalogsStore/loadRolesV2", requestParams); 
        if (roleList && roleList.length > 0) {
          rolesArray = roleList.map((el) => {
            let typeCountMap = [];
            if (el.attachments && el.attachments.length > 0) {
              typeCountMap = el.attachments.reduce((acc, att) => {
                acc[att.type] = (acc[att.type] || 0) + 1;
                return acc;
              }, {});
            }
            el.attachmentss = Object.entries(typeCountMap).map(
              ([type, quantity]) => ({ type, quantity })
            );

            let totalCount = 0;
            if (el.attachments_count) {
              totalCount = Object.values(el.attachments_count).reduce(
                (sum, count) => sum + count,
                0
              );
            }
            return {
              id: el.id,
              parentId: -1,
              status: el.status,
              archived: el.archived,
              data: {
                type: "role",
                code: el.code + "",
                name: el.name,
                status: el?.status,
              },
              info: {
                ...el,
              },
              attachedTo: {
                data: el.attachmentss,
              },
              attachedToItems: {
                data: el.attachmentss,
              },
              attachments_count: el.attachments_count,
              dashboard: {
                data: {
                  countApprentice: 0,
                  countProfessional: 0,
                  countCoach: 0,
                },
              },
              assignment: totalCount,
              types: "",
            };
          });
        }
        const rolesCount = this.$store.state.readinessCatalogsStore.rolesCount;
        this.rolesPaginationModel = {
          page: page,
          total: Math.ceil(rolesCount),
          perPage: 10,
        };
        }

       else if (this.$route?.params?.type === "responsibilities") {
        
        // Convert filters array to API filter object
        const apiFilters = this.convertFiltersToAPIFormat(filters);
        
        // Only include search and filters if they have meaningful values
        const requestParams = { limit, offset, include_badge_holders: true };
        if (search && search.trim()) {
          requestParams.search = search;
        }
        if (Object.keys(apiFilters).length > 0) {
          requestParams.filters = apiFilters;
        }
        
        // Attach ordering for responsibilities
        if (ordering) {
          requestParams.ordering = ordering;
        } else if (this.$store?.state?.readinessCatalogsStore?.responsibilitiesOrdering) {
          requestParams.ordering = this.$store.state.readinessCatalogsStore.responsibilitiesOrdering;
        }
        responsibilities = await this.$store.dispatch(
          "readinessCatalogsStore/loadResponsibilitiesV2", requestParams
        );

        if (responsibilities && responsibilities.length > 0) {
          responsibilitiesCopy = responsibilities.map((el) => {
            const newEl = {};
            newEl.id = el.id;
            newEl.realId = el.id;
            newEl.parentId = -1;
            newEl.status = el.status;
            newEl.archived = el.archived;
            el.code = el.code + "";
            newEl.data = {
              type: "responsibility",
              ...el,
            };
            newEl.type = "responsibility";
            return newEl;
          });
        }
        const responsibilitiesCount = this.$store.state.readinessCatalogsStore.responsibilitiesCount;
        this.responsibilitiesPaginationModel = {
          page: page,
          total: Math.ceil(responsibilitiesCount),
          perPage: 10,
        };
        }
        rolesArray.forEach((el) => {
          const responsibilitiesAttachments =
            el.info.attachments?.filter((ra) => ra.type == "responsibility") ||
            [];
          responsibilitiesAttachments.forEach((el2) => {
            const tempItem = responsibilitiesCopy.find(
              (res) => res.id == el2.id
            );
            if (tempItem) {
              const tempItemCopy = JSON.parse(JSON.stringify(tempItem));
              if (tempItemCopy) {
                let newId = itemsToAdd.length + 500;
                while (newId === el.id) {
                  newId = newId + 1000;
                }
                tempItemCopy.id = newId;
                tempItemCopy.realId = tempItem.id;
                tempItemCopy.parentId = el.id;
                tempItemCopy.type = "roles";
                itemsToAdd.push(tempItemCopy);
              }
            }
          });
        });
        const finalArray = JSON.parse(
          JSON.stringify(rolesArray.concat(itemsToAdd))
        );
        this.dataSourceRoles?.splice(
          0,
          this.dataSourceRoles.length,
          ...finalArray
        );
        this.dataSourceResponsibilities = JSON.parse(
          JSON.stringify(responsibilitiesCopy)
        );
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
    
    convertFiltersToAPIFormat(filters) {
      const apiFilters = {};
      let hasShowFilter = false;
      let hasDoNotShowFilter = false;
      
      filters.forEach(filter => {
        if (typeof filter === 'object' && filter.labelType) {
          switch (filter.labelType) {
            case 'Status':
              if (!apiFilters.status) {
                apiFilters.status = [];
              }
              if (filter.value && filter.value !== 'No Filter') {
                apiFilters.status.push(filter.value);
              }
              break;
            case 'Coverage':
              if (filter.value === 'No Masters') {
                apiFilters.no_masters = true;
              } else if (filter.value === 'No Coaches') {
                apiFilters.no_coaches = true;
              } else if (filter.value === 'No Professionals') {
                apiFilters.no_professionals = true;
              }
              break;
            case 'Archived':
              if (filter.value === 'Show') {
                hasShowFilter = true;
                apiFilters.archived = true;
              } else if (filter.value === 'Do not Show') {
                hasDoNotShowFilter = true;
                apiFilters.archived = false;
              }
              break;
            case 'Attachments':
              if (filter.value === 'No Positions' && this.$route?.params?.type === "responsibilities" ) {
                apiFilters.attachments = 'no';
              }
              else if (filter.value === 'No Positions' && this.$route?.name === "ReadinessCatalogsDetailObjId" ) {
                apiFilters.attachments = 'no';
              }
              else if (filter.value === 'No Positions' && this.$route?.name === "OrgPositionDetailObjId" ) {
                apiFilters.attachments = 'no';
              }
              else if (filter.value === 'No Positions' && this.$route?.params?.type === "roles") {
                apiFilters.positions = 'no';
              }
              else if (filter.value === 'No Responsibilities' && this.$route?.params?.type === "roles") {
                apiFilters.responsibilities = 'no';
              }
              break;
            case 'Timeline':
              if (filter.value === 'Recently Activated') {
                apiFilters.recently_activated = true;
              } else if (filter.value === 'Recently Retired') {
                apiFilters.recently_retired = true;
              } else if (filter.value === 'Recently Deactivated') {
                apiFilters.recently_deactivated = true;
              } else if (filter.value === 'Recently Created') {
                apiFilters.recently_created = true;
              }
              break;
          }
        } else if (typeof filter === 'object' && filter.value) {
          // Handle object filters without labelType but with value (status filters)
          if (!apiFilters.status) {
            apiFilters.status = [];
          }
          if (['draft', 'active', 'retired', 'inactive'].includes(filter.value)) {
            apiFilters.status.push(filter.value);
          }
        } else if (typeof filter === 'string') {
          // Handle string filters - need to determine the filter type based on the value
          if (['draft', 'active', 'retired', 'inactive'].includes(filter)) {
            // Status filters
            if (!apiFilters.status) {
              apiFilters.status = [];
            }
            apiFilters.status.push(filter);
          } else if (filter === 'No Positions') {
            // Attachments filter
            if (this.$route?.params?.type === "responsibilities" || this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
              apiFilters.attachments = 'no';
            }
            else if (this.$route?.params?.type === "roles" || this.$route?.name === "OrgPosition") {
              apiFilters.positions = 'no';
            }
          } 
          else if (filter === 'No Responsibilities') {
            apiFilters.responsibilities = 'no';
          }
          else if (filter === 'No Masters') {
            // Coverage filter
            apiFilters.no_masters = true;
          } else if (filter === 'No Coaches') {
            // Coverage filter
            apiFilters.no_coaches = true;
          } else if (filter === 'No Professionals') {
            // Coverage filter
            apiFilters.no_professionals = true;
          } else if (filter === 'Show') {
            // Archived filter
            hasShowFilter = true;
            apiFilters.archived = true;
          } else if (filter === 'Do not Show') {
            // Archived filter
            hasDoNotShowFilter = true;
            apiFilters.archived = false;
          } else if (filter === 'Recently Activated') {
            // Timeline filter
            apiFilters.recently_activated = true;
          } else if (filter === 'Recently Retired') {
            // Timeline filter
            apiFilters.recently_retired = true;
          } else if (filter === 'Recently Deactivated') {
            // Timeline filter
            apiFilters.recently_deactivated = true;
          } else if (filter === 'Recently Created') {
            // Timeline filter
            apiFilters.recently_created = true;
          }
        }
      });
      
      // Only apply archived=false if no archived filter is explicitly set
      if (!hasShowFilter && !hasDoNotShowFilter) {
        apiFilters.archived = false;
      }
      return apiFilters;
    },

    async loadNewDataSource() {
      await this.$store.dispatch("readinessCatalogsStore/loadRoles");
      await this.$store.dispatch("readinessCatalogsStore/loadResponsibilities");
    },
    async loadRolesAttachedToPosition({limit = 10, offset = 0, search = '', filters = [], page = 1, positionId}) {
      try {
        let roleList = []; 
          const apiFilters = this.convertFiltersToAPIFormat(filters);
        
          // Only include search and filters if they have meaningful values
          const requestParams = { limit, offset };
          if (search && search.trim()) {
            requestParams.search = search;
          }
          if (Object.keys(apiFilters).length > 0) {
            requestParams.filters = apiFilters;
          }
         roleList = await this.$store.dispatch("readinessCatalogsStore/loadRolesAttachedToPosition", {...requestParams, positionId}); 
        const rolesCount = this.$store.state.readinessCatalogsStore.rolesCount;

          this.paginationOrgRoleModel = {
            page: page,
            total: Math.ceil(rolesCount),
            perPage: 10,
          };
          
          // Save pagination to localStorage
          localStorage.setItem('paginationOrgRoleModel', JSON.stringify(this.paginationOrgRoleModel));
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
      async loadResponsibilitiesAttachedToRole({limit = 10, offset = 0, search = '', filters = [], page = 1, roleId, include_badge_holders = true}) {
      try {
        let roleList = [];
          const apiFilters = this.convertFiltersToAPIFormat(filters);
        
          // Only include search and filters if they have meaningful values
          const requestParams = { limit, offset, include_badge_holders };
          if (search && search.trim()) {
            requestParams.search = search;
          }
          if (Object.keys(apiFilters).length > 0) {
            requestParams.filters = apiFilters;

          }
         roleList = await this.$store.dispatch("readinessCatalogsStore/loadResponsibilitiesAttachedToRole", {...requestParams, roleId}); 
        const responsibilitiesCount = this.$store.state.readinessCatalogsStore.responsibilitiesCount;

          this.paginationRolePageModel = {
            page: page,
            total: Math.ceil(responsibilitiesCount),
            perPage: 10,
          };
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
    async loadDataSource() {
      try {
        const roleList = await this.$store.dispatch(
          "readinessCatalogsStore/loadRoles"
        );
        let rolesArray = [];
        if (roleList && roleList.length > 0) {
          rolesArray = roleList.map((el) => {
            let typeCountMap = [];
            if (el.attachments && el.attachments.length > 0) {
              typeCountMap = el.attachments.reduce((acc, att) => {
                acc[att.type] = (acc[att.type] || 0) + 1;
                return acc;
              }, {});
            }
            el.attachmentss = Object.entries(typeCountMap).map(
              ([type, quantity]) => ({ type, quantity })
            );

            let totalCount = 0;
            if (el.attachments_count) {
              totalCount = Object.values(el.attachments_count).reduce(
                (sum, count) => sum + count,
                0
              );
            }
            return {
              id: el.id,
              parentId: -1,
              status: el.status,
              archived: el.archived,
              data: {
                type: "role",
                code: el.code + "",
                name: el.name,
                status: el?.status,
              },
              info: {
                ...el,
              },
              attachedTo: {
                data: el.attachmentss,
              },
              attachedToItems: {
                data: el.attachmentss,
              },
              attachments_count: el.attachments_count,
              dashboard: {
                data: {
                  countApprentice: 0,
                  countProfessional: 0,
                  countCoach: 0,
                },
              },
              assignment: totalCount,
              types: "",
            };
          });
        }
        const itemsToAdd = [];

        const responsibilities = await this.$store.dispatch(
          "readinessCatalogsStore/loadResponsibilities"
        );

        let responsibilitiesCopy = [];

        if (responsibilities && responsibilities.length > 0) {
          responsibilitiesCopy = responsibilities.map((el) => {
            const newEl = {};
            newEl.id = el.id;
            newEl.realId = el.id;
            newEl.parentId = -1;
            newEl.status = el.status;
            newEl.archived = el.archived;
            el.code = el.code + "";
            newEl.data = {
              type: "responsibility",
              ...el,
            };
            newEl.type = "responsibility";
            newEl.types = "";
            newEl.dashboard = {
              data: {
                countApprentice: 0,
                countProfessional: 0,
                countCoach: 0,
              },
            };
            let typeCountRes = [];
            if (el.attachments && el.attachments.length > 0) {
              typeCountRes = el.attachments.reduce((acc, att) => {
                acc[att.type] = (acc[att.type] || 0) + 1;
                return acc;
              }, {});
            }
            el.attachments = Object.entries(typeCountRes).map(
              ([type, quantity]) => ({ type, quantity })
            );
            let totalCount = 0;
            if (el?.attachments_count) {
              totalCount = Object.values(el.attachments_count).reduce(
                (sum, count) => sum + count,
                0
              );
            }
            newEl.attachedTo = {
              data: el.attachments,
            };
            newEl.assignment = totalCount;
            return newEl;
          });
        }
        rolesArray.forEach((el) => {
          const responsibilitiesAttachments =
            el.info.attachments?.filter((ra) => ra.type == "responsibility") ||
            [];
          responsibilitiesAttachments.forEach((el2) => {
            const tempItem = responsibilitiesCopy.find(
              (res) => res.id == el2.id
            );
            if (tempItem) {
              const tempItemCopy = JSON.parse(JSON.stringify(tempItem));
              if (tempItemCopy) {
                let newId = itemsToAdd.length + 500;
                while (newId === el.id) {
                  newId = newId + 1000;
                }
                tempItemCopy.id = newId;
                tempItemCopy.realId = tempItem.id;
                tempItemCopy.parentId = el.id;
                tempItemCopy.type = "roles";
                itemsToAdd.push(tempItemCopy);
              }
            }
          });
        });
        const finalArray = JSON.parse(
          JSON.stringify(rolesArray.concat(itemsToAdd))
        );
        this.dataSourceRoles?.splice(
          0,
          this.dataSourceRoles.length,
          ...finalArray
        );
        this.dataSourceResponsibilities = JSON.parse(
          JSON.stringify(responsibilitiesCopy)
        );
      } catch (error) {
        console.error("Error loading roles: ", error);
      }
    },
    isWithinLast30Days(dateStr) {
      if (!dateStr) return false;
      const date = new Date(dateStr);
      const today = new Date();
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(today.getDate() - 30);
      return date >= thirtyDaysAgo && date <= today;
    },
    applyFiltersToDataSource(dataSource, routeType) {
      if(this.$route?.params?.type === "responsibilities" || this.$route?.params?.type === "roles" || this.$route?.name === "OrgPosition" || this.$route?.name === "ReadinessCatalogsDetailObjId") {
        return dataSource;
      }
      if(this.$route?.name === "ReadinessCatalogsDetail" || this.$route?.name === "ReadinessCatalogs" || this.$route?.name  === 'OrgPosition') {
        if(this.appliedFilters && this.appliedFilters.length > 0){
          if (this.appliedFilters.includes("Show")) {
            return dataSource;
          }
          if (this.appliedFilters.includes("No Positions")) {
            return dataSource.filter((item) => item.assignment == 0);
          }
          if (this.appliedFilters.includes("No Responsibilities")) {
            return dataSource.filter((item) =>  item.attachments_count?.responsibility === 0 ||  item.attachments_count?.responsibility === undefined)
          }
          else if (this.appliedFilters.includes("Do not Show")) {
            return dataSource.filter((item) => item.archived !== true);
          }
          if (this.appliedFilters.includes("Recently Activated")) {
            if (routeType === "roles") {
              const getActivateOn = (item) =>
                item.info?.activated_on || item.data?.activated_on;
              const isRecentlyActive = (item) =>
                item.status === "active" && this.isWithinLast30Days(getActivateOn(item));
              const activeItems = dataSource.filter(isRecentlyActive);
              const activeParentIds = activeItems
                .filter(item => item.parentId !== -1)
                .map(item => item.parentId);
              const activeIds = activeItems.map(item => item.id);
              const parentItems = dataSource.filter(
                item => activeParentIds.includes(item.id)
              );
              const childItems = dataSource.filter(
                item => activeIds.includes(item.parentId)
              );
              const combined = [...activeItems, ...parentItems, ...childItems];
              const unique = Array.from(new Map(combined.map(item => [item.id, item])).values());
              return unique;
            } else {
              return dataSource.filter(
                (el) =>
                  el.status === "active" &&
                  this.isWithinLast30Days(el.data?.activated_on)
              );
            }
          } else if (this.appliedFilters.includes("Recently Retired")) {
            if (routeType === "roles") {
              const getRemovedOn = (item) =>
                item.info?.removed_on || item.data?.removed_on;
              const isRecentlyRetired = (item) =>
                item.status === "retired" && this.isWithinLast30Days(getRemovedOn(item));
              const retiredItems = dataSource.filter(isRecentlyRetired);
              const retiredParentIds = retiredItems
                .filter(item => item.parentId !== -1)
                .map(item => item.parentId);
              const retiredIds = retiredItems.map(item => item.id);
              const parentItems = dataSource.filter(
                item => retiredParentIds.includes(item.id)
              );
              const childItems = dataSource.filter(
                item => retiredIds.includes(item.parentId)
              );
              const combined = [...retiredItems, ...parentItems, ...childItems];
              const unique = Array.from(new Map(combined.map(item => [item.id, item])).values());
              return unique;
            } else {
              return dataSource.filter(
                (el) =>
                  el.status === "retired" &&
                  this.isWithinLast30Days(el.data?.removed_on)
              );
            }
          } else if (this.appliedFilters.includes("Recently Created")) {
            if (routeType === "roles") {
              const getCreatedOn = (item) =>
                item.info?.created_on || item.data?.created_on;
              const isRecentlyDraft = (item) =>
                item.status === "draft" && this.isWithinLast30Days(getCreatedOn(item));
              const draftItems = dataSource.filter(isRecentlyDraft);
              const draftParentIds = draftItems
                .filter(item => item.parentId !== -1)
                .map(item => item.parentId);
              const draftIds = draftItems.map(item => item.id);
              const parentItems = dataSource.filter(
                item => draftParentIds.includes(item.id)
              );
              const childItems = dataSource.filter(
                item => draftIds.includes(item.parentId)
              );
              const combined = [...draftItems, ...parentItems, ...childItems];
              const unique = Array.from(new Map(combined.map(item => [item.id, item])).values());
              return unique;
            } else {
              return dataSource.filter(
                (el) =>
                  el.status === "draft" &&
                  this.isWithinLast30Days(el.data?.created_on)
              );
            }
          }
          const parentData = dataSource.filter(
            (item) =>
              this.appliedFilters.includes(item.status) &&
              item.parentId === -1
          );
          const parentIds = parentData.map((parent) => parent.id);
          const childItems = dataSource.filter((item) =>
          parentIds.includes(item.parentId)
        );
          return [...parentData, ...childItems];
        }
        return dataSource;
      }
      if (this.appliedFilters && this.appliedFilters.length > 0) {
        if (this.appliedFilters.includes("Show")) {
          console.log(dataSource);
          return dataSource;
        }
        else if (this.appliedFilters.includes("Do not show")) {
          return dataSource.filter((item) => item.archived !== true);
        }
        return dataSource.filter((item) =>
          this.appliedFilters.includes(item.status)
        );
      }
      return dataSource;
    },    
    async saveNewRole(roleName) {
      try {
        this.$loader.setAppLoading(true);
        const payload = {
          name: roleName,
          account: this.accountId,
        };
        let responseData;
        if(this.$route?.params?.type === "roles") {
          this.createNewRole = true;
          const { data } = await createRoleV2(this.accountId, payload);
          responseData = data;
        }
        else {
          const { data } = await createRole(this.accountId, payload);
          responseData = data;
        }
        const newRole = responseData;
        if(this.$route?.params?.type === "roles") {
          if(this.createNewRole) {
            this.searchItems = newRole;
            this.defaultSearch = newRole.code_str;
          }
          await this.loadDataSourceForReadinessCatalogs({
            limit: 10,
            offset: 0,
            search: newRole.code_str,
            filters: this.appliedFiltersFromAPI || [],
          });
          
          this.$loader.setAppLoading(false);
          this.closeDialog();
          highlight({ id: newRole.id, type: "Roles" });
          return;
        }
        else {
          await this.loadNewDataSource();
        }
        const newRoleIndex = this.sanitizeDataSource.findIndex(el => el.id === newRole.id);
        const page = Math.ceil((newRoleIndex + 1) / 10);
        this.paginationModel.page = page;
        this.dataSource = this.dataSourceRoles;
        const totalCount = this.sanitizeDataSource.filter(
          (el) => el.parentId == -1
        );
        this.paginationModel.total = totalCount.length;
        this.closeDialog();
        this.$loader.setAppLoading(false);
        highlight({ id: newRole.id, type: "Roles" });
      } catch (e) {
        console.error("error: ", e);
        let roleErrorMessage = e.response?.data?.[0];
        if(roleErrorMessage === 'Same name already exists') {
          this.roleErrorMessage = "Name already exists. Only Unique names are allowed";
        }
      } finally {
        this.$loader.setAppLoading(false);
      }
    },

    async processRoleActivation(
      activateResponsibilities = false,
      flagForPositionModal = false
    ) {
      try {
        this.$loader.setAppLoading(true);
        if(activateResponsibilities){
          this.activateButtonLoader = true;
        }
        else {
          this.skipButtonLoader = true;
        }
        const idRole = this.currentRole?.id;
        const payload = {
          account_id: this.accountId,
          role_id: idRole,
          ...(activateResponsibilities && { activate_responsibilities: true }),
        };
        await updateActiveRole(this.accountId, idRole, payload);

        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.activateRoleDialog = false;
          this.currentRole = null;
        } 
        else if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.actions.activateRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.activateRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.activateRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.activateRoleDialog = false;
          this.currentRole = null;

          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;

          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId === -1
          );
          const totalPages = Math.ceil(
            totalCount.length / this.rolesPaginationModel.perPage
          );

          this.rolesPaginationModel.page =
            totalPages > 0
              ? Math.min(this.rolesPaginationModel.page, totalPages)
              : 1;
        }
      } catch (e) {
        console.error("Role Activation Error: ", e);
        this.showActivateResponsibility = false;
      } finally {
        this.$loader.setAppLoading(false);
        // this.showActivateResponsibility = false;
        this.skipButtonLoader = false;
        this.activateButtonLoader = false;
        this.showActivateResponsibility = false;
      }
    },

    async activateRole(flagForPositionModal = false) {
      if (this.roleHasDraftResponsibility) {
        this.actions.activateRoleDialog = false;
        this.showActivateResponsibility = true;
        return;
      }
      await this.processRoleActivation(false, flagForPositionModal);
    },

    async skipActivateResponsibility(flagForPositionModal = false) {
      await this.processRoleActivation(false, flagForPositionModal);
    },

    async activateAttachedResponsibilities(flagForPositionModal = false) {
      await this.processRoleActivation(true, flagForPositionModal);
    },

    // async skipActivateResponsibility() {
    //   try {
    //     this.$loader.setAppLoading(true);
    //     const idRole = this.currentRole.id;
    //     const payload = {
    //       account_id: this.accountId,
    //       role_id: idRole,
    //     };
    //     await updateActiveRole(this.accountId, idRole, payload);
    //     this.actions.activateRoleDialog = false;
    //     this.currentRole = null;
    //     await this.loadDataSource();
    //     this.dataSource = this.dataSourceRoles;
    //     const totalCount = this.sanitizeDataSource.filter(
    //       (el) => el.parentId == -1
    //     );
    //     const totalPages = Math.ceil(
    //       totalCount?.length / this.paginationModel.perPage
    //     );
    //     if (this.paginationModel.page > totalPages && totalPages > 0) {
    //       this.paginationModel.page = totalPages;
    //     } else if (totalPages === 0) {
    //       this.paginationModel.page = 1;
    //     }
    //   } catch (e) {
    //     console.log("e: ", e);
    //   } finally {
    //     this.$loader.setAppLoading(false);
    //   }
    // },

    // async activateAttachedResponsibilities() {
    //   try {
    //     this.$loader.setAppLoading(true);
    //     const idRole = this.currentRole.id;
    //     const payload = {
    //       account_id: this.accountId,
    //       role_id: idRole,
    //       activate_responsibilities: true
    //     };
    //     await updateActiveRole(this.accountId, idRole, payload);
    //     this.actions.activateRoleDialog = false;
    //     this.currentRole = null;
    //     await this.loadDataSource();
    //     this.dataSource = this.dataSourceRoles;
    //     const totalCount = this.sanitizeDataSource.filter(
    //       (el) => el.parentId == -1
    //     );
    //     const totalPages = Math.ceil(
    //       totalCount?.length / this.paginationModel.perPage
    //     );
    //     if (this.paginationModel.page > totalPages && totalPages > 0) {
    //       this.paginationModel.page = totalPages;
    //     } else if (totalPages === 0) {
    //       this.paginationModel.page = 1;
    //     }
    //   } catch (e) {
    //     console.log("e: ", e);
    //   } finally {
    //     this.$loader.setAppLoading(false);
    //   }
    // },

    async attachedRole(flagForPositionModal = false) {
      try {
        this.$loader.setAppLoading(true);
        const objId = this.currentRole.id;
        const payload = {
          attachment_id: this.attachmentId,
        };
        await attachResponsibilityToRole(this.accountId, objId, payload);
        if (flagForPositionModal) {
          this.actions.attachedRoleDialog = false;
          this.currentRole = null;
          await this.viewState.reloadRoleData();
        }
        else if(this.$route?.params?.type === "roles" || this.$route?.params?.type === "responsibilities") {
          await this.reloadCurrentPageData();
          this.actions.attachedRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.attachedRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.attachedRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.attachedRoleDialog = false;
          this.currentRole = null;
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
        }
      } catch (e) {
        console.log("e: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    
    async retiredRole(flagForPositionModal = false) {
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentRole.id;
        const nameRole = this.currentRole.data.name;
        const payload = {
          name: nameRole,
          status: "retired",
          account: this.accountId,
        };
        await updateRetiredRole(this.accountId, idRole, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.retiredRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.actions.retiredRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.retiredRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.retiredRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.retiredRoleDialog = false;
          this.currentRole = null;
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.rolesPaginationModel.perPage
          );
          if (this.rolesPaginationModel.page > totalPages && totalPages > 0) {
            this.rolesPaginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.rolesPaginationModel.page = 1;
          }
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async reloadCurrentPageData(){
      const routeParams = this.$route?.params?.type || "roles";
      let paginationModel;
      
      if (routeParams === "responsibilities") {
        paginationModel = this.responsibilitiesPaginationModel;
      } else {
        paginationModel = this.rolesPaginationModel;
      }
      
      await this.loadDataSourceForReadinessCatalogs({
        limit: paginationModel.perPage,
        offset: (paginationModel.page - 1) * paginationModel.perPage,
        search: this.defaultSearch ? this.defaultSearch : this.searchItems?.name, 
        filters: this.appliedFiltersFromAPI,
        page: paginationModel.page,
        ordering: this.$store?.state?.readinessCatalogsStore?.ordering,
      });
      
      // Adjust pagination if current page exceeds total pages after data change
      let totalCount = 0;
      
      if (routeParams === "roles") {
        totalCount = this.$store.state.readinessCatalogsStore.rolesCount;
      } else if (routeParams === "responsibilities") {
        totalCount = this.$store.state.readinessCatalogsStore.responsibilitiesCount;
      }
      
      const totalPages = Math.ceil(totalCount / paginationModel.perPage);
      
      // If current page is greater than total pages and total pages > 0, adjust to last page
      if (paginationModel.page > totalPages && totalPages > 0) {
        paginationModel.page = totalPages;
        // Reload data with adjusted page
        await this.loadDataSourceForReadinessCatalogs({
          limit: paginationModel.perPage,
          offset: (paginationModel.page - 1) * paginationModel.perPage,
          search: this.defaultSearch,
          filters: this.appliedFiltersFromAPI,
          page: paginationModel.page,
          ordering: this.$store?.state?.readinessCatalogsStore?.ordering,
        });
      } else if (totalPages === 0) {
        // If no pages, go to page 1
        paginationModel.page = 1;
      }
      
      // Update total count
      paginationModel.total = totalCount;
    },
    async reloadOrgPositionData(){
      const savedPagination = localStorage.getItem('paginationOrgRoleModel');
      if (savedPagination) {
        this.paginationOrgRoleModel = JSON.parse(savedPagination);
      }
      let storeFilterKey = "organizationPositionRoleAttachmentrole";
      await this.$store.dispatch("filterStore/loadFilters", storeFilterKey);
      const savedFilters = this.$store.state.filterStore.filters;
      await this.loadRolesAttachedToPosition({
        limit: this.paginationOrgRoleModel.perPage,
        offset: (this.paginationOrgRoleModel.page - 1) * this.paginationOrgRoleModel.perPage,
        search: "",
        filters: savedFilters || [],
        page: this.paginationOrgRoleModel.page,
        positionId: this.$route.params.pId,
      });
      
      // Adjust pagination if current page exceeds total pages after data change
      let totalCount = 0;
      totalCount = this.$store.state.readinessCatalogsStore.rolesCount;
      
      const totalPages = Math.ceil(totalCount / this.paginationOrgRoleModel.perPage);
      
      // If current page is greater than total pages and total pages > 0, adjust to last page
      if (this.paginationOrgRoleModel.page > totalPages && totalPages > 0) {
        this.paginationOrgRoleModel.page = totalPages;
        // Reload data with adjusted page
        await this.loadRolesAttachedToPosition({
          limit: this.paginationOrgRoleModel.perPage,
          offset: (this.paginationOrgRoleModel.page - 1) * this.paginationOrgRoleModel.perPage,
          search: "",
          filters: savedFilters || [],
          page: this.paginationOrgRoleModel.page,
          positionId: this.$route.params.pId,
        });
      } else if (totalPages === 0) {
        // If no pages, go to page 1
        this.paginationOrgRoleModel.page = 1;
      }
      
      // Update total count
      if (this.paginationOrgRoleModel) {
        this.paginationOrgRoleModel.total = totalCount;
      }
    },
    async reloadOrgRoleData(){
      await this.loadResponsibilitiesAttachedToRole({
        limit: this.paginationRolePageModel.perPage,
        offset: (this.paginationRolePageModel.page - 1) * this.paginationRolePageModel.perPage,
        search: this.currentSearchTerm,
        filters: this.appliedFiltersFromAPI || [],
        page: this.paginationRolePageModel.page,
        roleId: this.currentRole.id,
      });
      
      // Adjust pagination if current page exceeds total pages after data change
      let totalCount = 0;
      totalCount = this.$store.state.readinessCatalogsStore.responsibilitiesCount;
      
      const totalPages = Math.ceil(totalCount / this.paginationRolePageModel.perPage);
      
      // If current page is greater than total pages and total pages > 0, adjust to last page
      if (this.paginationRolePageModel.page > totalPages && totalPages > 0) {
        this.paginationRolePageModel.page = totalPages;
        // Reload data with adjusted page
        await this.loadResponsibilitiesAttachedToRole({
          limit: this.paginationRolePageModel.perPage,
          offset: (this.paginationRolePageModel.page - 1) * this.paginationRolePageModel.perPage,
          search: "",
          filters: this.appliedFiltersFromAPI || [],
          page: this.paginationRolePageModel.page,
          roleId: this.currentRole.id,
        });
      } else if (totalPages === 0) {
        // If no pages, go to page 1
        this.paginationRolePageModel.page = 1;
      }
      
      // Update total count
      if (this.paginationRolePageModel) {
        this.paginationRolePageModel.total = totalCount;
      }
    },
    async archiveRole(type = "") {
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentRole.id;
        const objTpye = 'role' 

        await updateArchiveRole(this.accountId, objTpye, idRole);
        if (type === "attachRoles") {
          this.showArchihvedResponsiblityDialog = false;
        } else {
          this.actions.showArchiveDialog = false;
        }
        if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        }
        else {
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
        }
        this.currentRole = null;
        const totalCount = this.sanitizeDataSource.filter(
          (el) => el.parentId == -1
        );
        const totalPages = Math.ceil(
          totalCount?.length / this.paginationModel.perPage
        );
        if (this.paginationModel.page > totalPages && totalPages > 0) {
          this.paginationModel.page = totalPages;
        } else if (totalPages === 0) {
          this.paginationModel.page = 1;
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async unarchiveRole(type = "") {
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentRole.id;
        const objTpye = 'role' 

        await updateUnArchiveRole(this.accountId, objTpye, idRole);
        if (type === "attachRoles") {
          this.showArchihvedResponsiblityDialog = false;
        } else {
          this.actions.showArchiveDialog = false;
          this.currentRole = null;
        }
        if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        }
        else {
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
        }
        const totalCount = this.sanitizeDataSource.filter(
          (el) => el.parentId == -1
        );
        const totalPages = Math.ceil(
          totalCount?.length / this.paginationModel.perPage
        );
        if (this.paginationModel.page > totalPages && totalPages > 0) {
          this.paginationModel.page = totalPages;
        } else if (totalPages === 0) {
          this.paginationModel.page = 1;
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async renameRole(newName, flagForPositionModal = false) {
      let payload;
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole?.id;
        let updatedRole;
        if (!idRole) {
          throw "no id";
        }
        payload = {
          name: newName,
        };
        updatedRole = await updateNameRole(this.accountId, idRole, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.showRenameRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.params?.type === "roles") {
          if(this.createNewRole) {
            this.searchItems = updatedRole;
            this.defaultSearch = updatedRole.data.code_str;
          }
          await this.reloadCurrentPageData();
          this.actions.showRenameRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.showRenameRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.showRenameRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.showRenameRoleDialog = false;
          this.currentRole = null;
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
        }
      } catch (e) {
        console.log("e: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async deleteRole(val, flagForPositionModal = false) {
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole.id;
        const payload = {
          delete_draft_responsibilities: val,
        };
        if (val) {
          await deleteReadinessRoleWithResponsibilities(
            this.accountId,
            idRole,
            payload
          );
        } else {
          await deleteReadinessRole(this.accountId, idRole);
        }

        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.deleteRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.actions.deleteRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.deleteRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.deleteRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.deleteRoleDialog = false;
          this.currentRole = null;
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
          const totalItemsAfterDeletion = this.paginationModel.total - 1;
          const totalPages = Math.ceil(
            totalItemsAfterDeletion / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
          this.paginationModel.total = totalItemsAfterDeletion;
        }
      } catch (e) {
        console.log("e: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async addResponsibility(name) {
      try {
        const payload = {
          name: name,
          account: this.accountId,
        };
        const newRes = await createResponsibility(this.accountId, payload);
        await this.loadResponsibilities();
        this.dataSource = this.dataSourceRoles;
        return newRes;
      } catch (e) {
        console.log("e: ", e);
      }
    },
    async deActivateRole(flagForPositionModal = false){
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentRole.id;
        const nameRole = this.currentRole.data.name;
        const payload = {
          name: nameRole,
          status: "inactive",
          account: this.accountId,
        };
        await updateDeActiveRole(this.accountId, idRole, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.deActivateRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.actions.deActivateRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.deActivateRoleDialog = false;
          this.currentRole = null;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.deActivateRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.deActivateRoleDialog = false;
          this.currentRole = null;
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
        }
        const totalCount = this.sanitizeDataSource.filter(
          (el) => el.parentId == -1
        );
        const totalPages = Math.ceil(
          totalCount?.length / this.rolesPaginationModel.perPage
        );
        if (this.rolesPaginationModel.page > totalPages && totalPages > 0) {
          this.rolesPaginationModel.page = totalPages;
        } else if (totalPages === 0) {
          this.rolesPaginationModel.page = 1;
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async reActivateRole(flagForPositionModal = false) {
      this.$loader.setAppLoading(true);
      try {
        const idRole = this.currentRole.id;
        const nameRole = this.currentRole.data.name;
        const payload = {
          name: nameRole,
          status: "inactive",
          account: this.accountId,
        };
        await updateReActiveRole(this.accountId, idRole, payload);
        if (flagForPositionModal) {
          await this.viewState.reloadRoleData();
          this.actions.reActivateRoleDialog = false;
          this.currentRole = null;
        } else if(this.$route?.params?.type === "roles") {
          await this.reloadCurrentPageData();
          this.actions.reActivateRoleDialog = false;
          this.currentRole = null;
        } else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.actions.reActivateRoleDialog = false;
          this.currentRole = null;
        } else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.actions.reActivateRoleDialog = false;
          this.currentRole = null;
        }
        else {
          this.actions.reActivateRoleDialog = false;
          this.currentRole = null;
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
          const totalCount = this.sanitizeDataSource.filter(
            (el) => el.parentId == -1
          );
          const totalPages = Math.ceil(
            totalCount?.length / this.paginationModel.perPage
          );
          if (this.paginationModel.page > totalPages && totalPages > 0) {
            this.paginationModel.page = totalPages;
          } else if (totalPages === 0) {
            this.paginationModel.page = 1;
          }
        }
      } catch (e) {
        console.log("e: ", e);
      }
      this.$loader.setAppLoading(false);
    },
    async loadPositionByID(accountId, posId) {
      const { data } = await getPositionId(accountId, posId);
      if (data) {
        this.currentPosition = data;
        this.positionHeaderState = {
          status: data.status,
          icon: "org_icon_position",
          label: "Position",
          code: this.getOrgCodeName(data),
          name: data.name,
          archived: data.archived || false,
          assigned_employees: data.assigned_employees,
        };
      }
    },
    getOrgCodeName(position) {
      if (position?.code_str) {
        return position.code_str.split(" ")[0];
      } else {
        return "#" + position?.code;
      }
    },
    detachItem(data) {
      this.currentItem = {
        name: data?.name,
        type: data?.type,
        ...data,
      };
      this.parentName = data?.parentName;
      this.actions.showDetachDialog = true;
    },
    detachAction() {
      if (this.currentItem.type === "responsibility") {
        this.detachResponsibilityAction(this.currentItem);
      } else if (this.currentItem.type === "position") {
        this.detachRoleAction(this.currentItem);
      }
      this.actions.showDetachDialog = false;
    },
    async detachRoleAction(data) {
      try {
        const payload = {
          parent_id: data.id,
        };
        await detachRoleAttachment(this.accountId, data.parentId, payload);
        if(this.$route?.params?.type === "roles" || this.$route?.params?.type === "responsibilities") {
          await this.reloadCurrentPageData();
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        }
        else {
          await this.loadDataSource();
        }
      } catch (e) {
        console.error("e: ", e);
      }
    },
    async detachResponsibilityAction(data) {
      try {
        const payload = {
          parent_id: data.parentId,
        };
        await detachAttachments(this.accountId, data.id, payload);
        if(this.$route?.params?.type === "roles" || this.$route?.params?.type === "responsibilities") {
          await this.reloadCurrentPageData();
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        }
        else {
          await this.loadDataSource();
        }
      } catch (e) {
        console.error("e: ", e);
      }
    },
    async detachItems(data, callback) {
      console.log("detachItems called with data:", JSON.stringify(data, null, 2));
      this.$loader.setAppLoading(true);
      this.detachLoader = true;
      const targetObj = data.target;
      const detachObj = data.detachObj;
      console.log("detachItems - Extracted targetObj:", JSON.stringify(targetObj, null, 2), "detachObj:", JSON.stringify(detachObj, null, 2));
      try {
        // Ensure accountId is set
        if (!this.accountId) {
          this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        }
        
        if (!targetObj || !detachObj) {
          console.error("detachItems: Missing targetObj or detachObj", { targetObj, detachObj });
          return;
        }
        
        // Handle both objectType (capitalized like "Role", "Responsibility") and type (lowercase)
        const targetTypeRaw = targetObj.objectType || targetObj.type || "";
        const targetType = targetTypeRaw.toLowerCase();
        const detachTypeRaw = detachObj.type || detachObj.objectType || "";
        const detachType = detachTypeRaw.toLowerCase();
        
        console.log("detachItems - targetObj:", JSON.stringify(targetObj, null, 2), "detachObj:", JSON.stringify(detachObj, null, 2), "targetType:", targetType, "detachType:", detachType);
        
        let apiCalled = false;
        
        if (targetType === "role") {
          if (detachType === "position") {
            // detach role from position
            const payload = {
              childType: "role",
              childId: targetObj.objectId || targetObj.id,
              parentData: {
                parent_id: detachObj.id,
              },
            };
            console.log("Calling detachOrgObject - detach role from position, payload:", payload);
            await detachOrgObject(this.accountId, payload);
            console.log("detachOrgObject completed successfully");
            apiCalled = true;
          } else if (detachType === "role") {
            // detach role from role (role-to-role attachment)
            const payload = {
              childType: "role",
              childId: detachObj.id,
              parentData: {
                parent_id: targetObj.objectId || targetObj.id,
              },
            };
            console.log("Calling detachOrgObject - detach role from role, payload:", payload);
            await detachOrgObject(this.accountId, payload);
            console.log("detachOrgObject completed successfully");
            apiCalled = true;
          } else if (detachType === "responsibility") {
            // detach responsibility from role
            const payload = {
              childType: "responsibility",
              childId: detachObj.id,
              parentData: {
                parent_id: targetObj.objectId || targetObj.id,
              },
            };
            console.log("Calling detachOrgObject - detach responsibility from role, payload:", payload);
            await detachOrgObject(this.accountId, payload);
            console.log("detachOrgObject completed successfully");
            apiCalled = true;
          } else {
            console.warn("detachItems: Unknown detachType for role:", detachType, "Full detachObj:", JSON.stringify(detachObj));
          }
        } else if (targetType === "responsibility") {
          // Detach responsibility from role or position
          const payload = {
            childType: "responsibility",
            childId: targetObj.objectId || targetObj.id,
            parentData: {
              parent_id: detachObj.id,
            },
          };
          console.log("Calling detachOrgObject - detach responsibility, payload:", payload);
          await detachOrgObject(this.accountId, payload);
          console.log("detachOrgObject completed successfully");
          apiCalled = true;
        } else {
          console.warn("detachItems: Unknown targetType:", targetType, "Full targetObj:", JSON.stringify(targetObj, null, 2), "Full detachObj:", JSON.stringify(detachObj, null, 2));
        }
        
        if (!apiCalled) {
          console.error("detachItems: No API call was made! targetType:", targetType, "detachType:", detachType);
        }
        
        // Only reload if detach API was successfully called
        if(this.$route?.params?.type === "roles" || this.$route?.params?.type === "responsibilities" || this.$route?.name === "ReadinessCatalogsDetail" || this.$route?.name === "ReadinessCatalogs") {
          await this.reloadCurrentPageData();
          this.detachLoader = false;
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
          this.detachLoader = false;
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
          this.detachLoader = false;
        }
        else {
          await this.loadDataSource();
        }
        if (data.closeFn) {
          data.closeFn();
        }
        if (callback) {
          callback();
        }        
      } catch (e) {
        console.error("Error in detachItems:", e);
        console.error("Error details:", {
          message: e.message,
          response: e.response,
          targetObj,
          detachObj
        });
        // Don't reload data if detach failed
        this.$loader.setAppLoading(false);
        this.detachLoader = false;
        throw e; // Re-throw to let caller handle
      } finally {
        this.$loader.setAppLoading(false);
        this.detachLoader = false;
      }
    },
    async openChatterDrawer(typeData, isLoadMore = false) {
      // If this is initial load (not load more), reset the data and start from page 1
      if (!isLoadMore) {
        this.chatterData = [];
        this.totalChatterData = 0;
      }
      
      const id = (typeData.data.type === "role") ? typeData.id : typeData.realId;
      const type = typeData.data.type;
      
      // Calculate page based on current data length
      const page = Math.floor(this.chatterData.length / 10) + 1;
      
      const { data } = await getChatterList(
        this.accountId,
        id,
        type,
        page
      );
      
      if (data && data.count) {
        this.totalChatterData = data.count;
      }
      if (data && data.results) {
        let chatterItems = data.results.map((el) => {
          const date = new Date(el.recorded_on);
          const milliseconds = date.getTime();
          const millisecondsString = milliseconds.toString();
          let nameParts = el.recorded_by_name.split(" ");
          const newEl = {};
          newEl.id = el.id;
          if (nameParts.length === 2) {
            newEl.avatar = {
              picture: "",
              firstName: nameParts[0],
              lastName: nameParts[1],
            };
          } else {
            newEl.avatar = {
              picture: "",
              firstName: el.recorded_by_name,
              lastName: "",
            };
          }
          newEl.IsExIQtiveBot = false;
          newEl.message = el.note;
          newEl.created_on = millisecondsString;
          newEl.IsHistory = el.is_history;
          return newEl;
        });
        this.chatterData.push(...chatterItems);
      }
    },
    async loadMoreChatterData(typeData) {
      // Call openChatterDrawer with isLoadMore = true to append data
      await this.openChatterDrawer(typeData, true);
    },
    async attachedResponsibilityToRole() {
      try {
        this.$loader.setAppLoading(true);
        const objId = this.attachmentId;
        const payload = {
          attachment_id: this.currentResponsibilityId ? this.currentResponsibilityId : this.currentResponsibility?.data?.id,
        };
        await attachResponsibilityToRole(this.accountId, objId, payload);
        this.actions.showAttachRoleDialog = false;
        this.currentResponsibility = null;
        this.currentResponsibilityId = null;
        if(this.$route?.params?.type === "roles" || this.$route?.params?.type === "responsibilities") {
          await this.reloadCurrentPageData();
        }
        else if(this.$route?.name === "OrgPosition") {
          await this.reloadOrgPositionData();
        }
        else if(this.$route?.name === "ReadinessCatalogsDetailObjId" || this.$route?.name === "OrgPositionDetailObjId") {
          await this.reloadOrgRoleData();
        }
        else {
          await this.loadDataSource();
          this.dataSource = this.dataSourceRoles;
        }
      } catch (e) {
        console.log("e: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
  },
};
